// Companysettings codes for Google Ads conversion tracking.
// Must match GoogleAdsPolicy on the API.
export const GOOGLE_ADS_CODES = {
  ENABLED: 'google_ads_enabled',
  CONVERSION_ID: 'google_ads_conversion_id',
  CONVERSION_LABEL: 'google_ads_conversion_label',
};

export const GOOGLE_ADS_SOURCE = 'google_ads';

const settingValue = (settingsMap, code) => settingsMap?.[code]?.value ?? '';

const CONVERSION_ID = /^(AW-)?\d{6,12}$/i;
const CONVERSION_LABEL = /^[A-Za-z0-9_-]{4,64}$/;

export const normalizeConversionId = (raw) => {
  const value = (raw || '').trim();
  if (!CONVERSION_ID.test(value)) return '';
  return value.toUpperCase().startsWith('AW-') ? `AW-${value.slice(3)}` : `AW-${value}`;
};

export const readGoogleAdsSettings = (settingsMap) => {
  const enabled =
    settingValue(settingsMap, GOOGLE_ADS_CODES.ENABLED).trim().toLowerCase() ===
    'true';
  return {
    enabled,
    conversionId: settingValue(settingsMap, GOOGLE_ADS_CODES.CONVERSION_ID).trim(),
    conversionLabel: settingValue(
      settingsMap,
      GOOGLE_ADS_CODES.CONVERSION_LABEL,
    ).trim(),
  };
};

export const isValidConversionId = (value) =>
  Boolean(normalizeConversionId(value));

export const isValidConversionLabel = (value) =>
  CONVERSION_LABEL.test((value || '').trim());

export const canEnableGoogleAds = ({ conversionId, conversionLabel }) =>
  isValidConversionId(conversionId) && isValidConversionLabel(conversionLabel);
